<template>
  {{ text }}
</template>

<script setup>

const props = defineProps({
  score: {
    type: Number,
    default: 0,
  },
});

const text = (() => {
  if (props.score >= 4.5) {
    return 'Excellent communication';
  }
  if (props.score >= 3) {
    return 'Pleasant communication';
  }
  if (props.score >= 2.5) {
    return 'Passable communication';
  }
  if (props.score >= 1.5) {
    return 'Poor communication';
  }
  return 'Very poor communication';
})();
</script>
